module.exports = __webpack_public_path__ + "img/ASFT_visualisoinnit_muokatut-03.2ec17514.png";